import React from 'react';
import AppApi from "../../api/app";
import toast from 'react-hot-toast';
import gallery from "../../api/gallery";
import * as Yup from "yup";
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../store/actions';

import { ErrorMessage, Field, Form, Formik } from "formik";
let validationSchema = Yup.object({
   name: Yup.string().required("Name  is required."),
   businessName: Yup.string().required("Business name is required."),
   address: Yup.string().required("Address is required"), 
});

function UpdateProfile({ data }) {
   let dispatch = useDispatch();
   return (
      <> 
         <Formik
            initialValues={{
               name: data?.name || "",
               businessName: data?.businessName || "",
               address: data?.address || "",
               websiteUrl: data?.websiteUrl || "", 
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
               setSubmitting(true);
               try {
                  let res = "";
                  if (data?._id) {
                     res = await AppApi.updateProfile(values);
                  }
                  if (res?.data?.error == false) {
                     toast.success(res?.data?.msg);
                     dispatch(Actions.addProfile(res?.data?.data));
                  }
                  setSubmitting(false);
               } catch (error) {
                  console.log(error.message);
                  setSubmitting(false);
               }
            }}
         >
            {({ isSubmitting, values, errors, setFieldValue }) => (
               <Form>
                  <div className=" form mt-1">
                     <div className="form-group flex-grow-1">
                        <label>Name</label>
                        <Field
                           name="name"
                           type="text"
                           className="form-control rounded"
                           placeholder="location title"
                        />
                        <ErrorMessage component="small" className='text-danger' name="name" />
                     </div>
                  </div>
                  <div className="form-group mt-1">
                     <label>Business Name</label>
                     <Field
                        name="businessName"
                        type="text"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="businessName" />
                  </div>
                  <div className="form-group mt-1">
                     <label>Business Address</label>
                     <Field
                        name="address"
                        type="text"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="address" />
                  </div>
                  <div className="p-0 mt-5 text-left col-sm-12">
                     <div className="mb-1 form-group d-flex justify-content-end">
                        <button type="submit" disabled={isSubmitting} className=" btn rounded-0 btn-dark">{isSubmitting ? "Loading..." : data?._id ? "Update" : "Update"}</button>
                     </div>
                  </div>
               </Form>
            )}
         </Formik>
      </>
   )
}

export default UpdateProfile